import React, { useState } from "react";
import Input from "../components/Input";
import { PropTypes } from "prop-types";

const SubscribeFrm = ({ onSubmit }) => {
  const [data, setData] = useState("");

  const submitHandler = () => {
    // send to parent
    if (data) onSubmit(data);
  };

  return (
    <div className="row align-items-center justify-content-center">
      <div className="col col-md-auto">
        <Input
          type="text"
          placeholder="Email address"
          onChange={v => setData(v)}
        />
      </div>
      <div className="col-md-auto">
        {" "}
        <div
          className="btn-lg btn-primary"
          style={{ fontSize: "inherit" }}
          onClick={submitHandler}
        >
          Subscribe
        </div>
      </div>
    </div>
  );
};

SubscribeFrm.propTypes = {
  onSubmit: PropTypes.func.isRequired
};

export default SubscribeFrm;
